import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import UpdatePage from '../../../composents/UpdatePage'

const title = 'Restrictions'
const headers = {
  icon: 'feather icon-edit',
  title: title,
  description: 'update of restriction',
  breadcrumbs: [
    {
      title: title,
      link: '/water_cards/restrictions',
    },
  ],
}

export default function EditCardPermission() {
  const [loader, setLoader] = useState(false),
    [fail, setFail] = useState(false),
    [loading, setLoading] = useState(true),
    { id } = useParams(),
    [errors, setErrors] = useState({}),
    [data, setData] = useState({}),
    [type, setType] = useState(),
    [mode, setMode] = useState(),
    [allTypeData, setAllTypeData] = useState([]),
    types = [
      {
        value: 'client',
        label: 'Restricted to a Client',
      },
      {
        value: 'meter',
        label: 'Restricted to meter',
      },
      {
        value: 'zone',
        label: 'Restricted to a Zone',
      },
      {
        value: 'city',
        label: 'Restricted to a City',
      },
      {
        value: 'country',
        label: 'Restricted to a Country',
      },
    ],
    modes = [
      {
        value: 'entire group',
        label: 'Entire group',
      },
      {
        value: 'list only',
        label: 'List only',
      },
      {
        value: 'group exept list',
        label: 'Group exept list',
      },
    ],
    [customers, setCustomers] = useState([]),
    [customer, setCustomer] = useState(),
    [meters, setMeters] = useState([]),
    [zones, setZones] = useState([]),
    [cities, setCities] = useState([]),
    [countries, setCountries] = useState([]),
    [elements, setElements] = useState([])

  async function onGet() {
    setLoading(true)
    const response = await resources.cardPermission
      .readOne(id)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (response.status === 200) {
      setData(response.data)
      const typeFilter = types.filter((type) => type.value === response.data?.type)
      setType(typeFilter[0])
      setMode({
        label: ucFirst(response.data.mode),
        value: response.data.mode,
      })
    } else if (response.status === 403) {
      setFail(true)
    }

    let cli = await resources.customer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cli.status === 200) {
      let a = []
      let b = []
      cli.data.docs.forEach((el) => {
        if (response.data?.type === 'client') {
          response.data.restrictions.forEach((element) => {
            if (element === el.id) {
              b.push({
                value: el.id,
                label: el.name,
              })
            }
          })
        }

        if (response.data.client === el.id) {
          setCustomer({
            value: el.id,
            label: el.name,
          })
        }
        a.push({
          value: el.id,
          label: el.name,
        })
      })
      if (b.length !== 0) {
        setAllTypeData(b)
        setElements(a)
      }
      setCustomers(a)
    }

    let met = await resources.meter
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (met.status === 200) {
      let a = []
      let b = []
      met.data.docs.forEach((el) => {
        if (response.data?.type === 'meter') {
          response.data.restrictions.forEach((element) => {
            if (element === el.id) {
              b.push({
                value: el.id,
                label: el.code,
                client: el.client,
              })
            }
          })
        }

        a.push({
          value: el.id,
          label: el.code,
          client: el.client,
        })
      })
      if (b.length !== 0) {
        setAllTypeData(b)
        setElements(a)
      }
      setMeters(a)
    }

    let zo = await resources.zone
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (zo.status === 200) {
      let a = []
      let b = []
      zo.data.docs.forEach((el) => {
        if (response.data?.type === 'zone') {
          response.data.restrictions.forEach((element) => {
            if (element === el.id) {
              b.push({
                value: el.id,
                label: el.zone + ' | ' + el.location,
                client: el.client.id,
              })
            }
          })
        }

        a.push({
          value: el.id,
          label: el.zone + ' | ' + el.location,
          client: el.client.id,
        })
      })
      if (b.length !== 0) {
        setAllTypeData(b)
        setElements(a)
      }
      setZones(a)
    }

    let cit = await resources.city
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cit.status === 200) {
      let a = []
      let b = []
      cit.data.docs.forEach((el) => {
        if (response.data?.type === 'city') {
          response.data.restrictions.forEach((element) => {
            if (element === el.id) {
              b.push({
                value: el.id,
                label: el.name,
              })
            }
          })
        }
        a.push({
          value: el.id,
          label: el.name,
        })
      })
      if (b.length !== 0) {
        setAllTypeData(b)
        setElements(a)
      }
      setCities(a)
    }

    let cou = await resources.country
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cou.status === 200) {
      let a = []
      let b = []
      cou.data.docs.forEach((el) => {
        if (response.data?.type === 'country') {
          response.data.restrictions.forEach((element) => {
            if (element === el.id) {
              b.push({
                value: el.id,
                label: el.name,
              })
            }
          })
        }

        a.push({
          value: el.id,
          label: el.name,
        })
      })
      if (b.length !== 0) {
        setAllTypeData(b)
        setElements(a)
      }
      setCountries(a)
    }
    setLoading(false)
  }

  useEffect(() => {
    onGet()
  }, [])

  useEffect(() => {
    switch (type?.value) {
      case 'client':
        setElements(customers)
        break
      case 'meter':
        setElements(meters)
        break
      case 'zone':
        setElements(zones)
        break
      case 'city':
        setElements(cities)
        break
      case 'country':
        setElements(countries)
        break
      default:
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = {}
    formData.forEach((value, key) => (object[key] = value))
    if (type) object.type = type.value
    if (allTypeData) object.restrictions = allTypeData.map((e) => e.value)
    if (customer) object.client = customer.value
    setLoader(true)
    setErrors({})
    let res = await resources.cardPermission
      .update(id, object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/hydrowallet/restrictions')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterAll = () => {
    let all_cities = []
    if (customer) {
      if (type.value !== 'city' && type.value !== 'country' && type.value !== 'client') {
        all_cities = elements.filter((e) => e.client === customer.value)
      } else {
        all_cities = elements
      }
    }
    return all_cities
  }

  const ucFirst = (str) => {
    if (typeof str === 'string' && str.length > 0) {
      return str[0].toUpperCase() + str.slice(1)
    }

    return ''
  }

  return (
    <UpdatePage
      show_error={errors['not_autorized']}
      loading={loading}
      fail={fail}
      headers={headers}
    >
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Client{' '}
                    <span
                      style={{
                        color: 'red',
                      }}
                    >
                      *
                    </span>
                  </label>
                  <Select
                    onChange={setCustomer}
                    options={customers}
                    required
                    value={customer}
                    isSearchable
                    isClearable
                  />
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Type of restriction{' '}
                    <span
                      style={{
                        color: 'red',
                      }}
                    >
                      *
                    </span>
                  </label>
                  <Select
                    onChange={(e) => {
                      setType(e)
                      setAllTypeData([])
                    }}
                    options={types}
                    value={type}
                    isSearchable
                    isClearable={false}
                    className={errors['type'] ? ' is-invalid' : ''}
                  />
                  {errors['type'] && <div className="invalid-feedback">{errors['type']}</div>}
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    {type?.value}{' '}
                    <span
                      style={{
                        color: 'red',
                      }}
                    >
                      *
                    </span>
                  </label>
                  <Select
                    onChange={setAllTypeData}
                    isMulti
                    value={allTypeData}
                    options={filterAll()}
                    className={errors['restrictions'] ? ' is-invalid' : ''}
                  />

                  {errors['restrictions'] && (
                    <div className="invalid-feedback">{errors['restrictions']}</div>
                  )}
                </div>

                <Field
                  name="title"
                  className="mb-3"
                  error={errors['title']}
                  required
                  defaultValue={data.title}
                >
                  Title
                </Field>

                <Field
                  name="code"
                  className="mb-3"
                  error={errors['code']}
                  disabled
                  defaultValue={data.code}
                >
                  Code
                </Field>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Mode{' '}
                    <span
                      style={{
                        color: 'red',
                      }}
                    >
                      *
                    </span>
                  </label>
                  <Select
                    name="mode"
                    options={modes}
                    onChange={setMode}
                    isSearchable
                    value={mode}
                    isClearable={false}
                    className={errors['mode'] ? ' is-invalid' : ''}
                  />
                  {errors['mode'] && <div className="invalid-feedback">{errors['mode']}</div>}
                </div>

                <Field
                  name="description"
                  className="mb-3"
                  error={errors['description']}
                  defaultValue={data.description}
                  type="textarea"
                >
                  Note
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary " onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </UpdatePage>
  )
}
